import { render } from "./orderOverview.vue?vue&type=template&id=a75a8074&ts=true"
import script from "./orderOverview.vue?vue&type=script&lang=ts"
export * from "./orderOverview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__